import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from '../../../../../../../core/shared/widget/widget-data';
import {FilterCriteria} from '../../../../../../../core/shared/filter/api/filter.criteria';
import {WidgetFactory} from '../../../../../../../core/shared/widget/service/widget.factory';
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from '../../../../../../../core/shared/helper/widget-function-call-back-create';

@Component({
    selector: 'bm-billing-area-partners',
    templateUrl: 'bm-billing-area-partners.component.html',
    standalone: false
})
export class BmBillingAreaPartnersComponent implements OnInit, OnChanges, OnDestroy {

    initialized: boolean = false;

    @Input() billingAreaId: number;

    billingAreaPartnersWidgetData: WidgetData;

    ngOnInit(): void {
        this.refreshComponent();
    }

    refreshComponent() {
        const filterCriteria = FilterCriteria.create(
            'e.billingAreaId',
            FilterCriteria.cOperatorEqual,
            this.billingAreaId
        );

        this.billingAreaPartnersWidgetData = WidgetFactory.createWidgetTableEntityBasicQl(
            `bm.billing.area.partners.widget.data.${this.billingAreaId}`,
            'Bereichspartner',
            'bm.BillingAreaPartner',
            [filterCriteria]
        );

        const fields: WidgetToolbarCreateInterface[] = [
            {fieldName: 'billingAreaDtoId', fieldValue: this.billingAreaId}
        ];
        this.billingAreaPartnersWidgetData.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);

        this.initialized = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes['billingAreaId']) {
            this.refreshComponent();
        }
    }

    ngOnDestroy(): void {
    }
}
